module.exports = __webpack_public_path__ + "static/media/file-fig.33fb711a.svg";